import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  LIST_PROPERTY_FOR_RENT: '10051',
  ADD_TENANT: '10052',
  INVITE_TO_APPLY: '10053',
  ADD_LEASE: '10054',
  SET_UP_PAYMENTS: '10055',
} as const;

type EventProps = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
};

// https://dataportal.zillowgroup.net/event-registry/10051
export const emitListPropertyForRentEvent = ({ currentProperty, user }: EventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.LIST_PROPERTY_FOR_RENT,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'property_added_next_steps',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'list_property_for_rent',
      trigger_source_nm: 'create_listing',
    },
    semantic: {
      semantic_event_nm: 'new_ia_list',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/10052
export const emitAddTenantEvent = ({ currentProperty, user }: EventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ADD_TENANT,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'property_added_next_steps',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'add_a_tenant',
      trigger_source_nm: 'add_a_tenant',
    },
    semantic: {
      semantic_event_nm: 'new_ia_add_tenant',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/10053
export const emitInviteToApplyEvent = ({ currentProperty, user }: EventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.INVITE_TO_APPLY,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'property_added_next_steps',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'invite_to_apply',
      trigger_source_nm: 'invite_to_apply',
    },
    semantic: {
      semantic_event_nm: 'new_ia_invite_to_apply',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/10054
export const emitAddLeaseEvent = ({ currentProperty, user }: EventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ADD_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'property_added_next_steps',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'add_lease',
      trigger_source_nm: 'add_lease',
    },
    semantic: {
      semantic_event_nm: 'new_ia_add_lease',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/10055
export const emitSetUpPaymentsEvent = ({ currentProperty, user }: EventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SET_UP_PAYMENTS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'property_added_next_steps',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'set_up_payments',
      trigger_source_nm: 'set_up_payments',
    },
    semantic: {
      semantic_event_nm: 'new_ia_set_up_payments',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
